export default [
  {
    path: '/v2/payment/banks',
    name: 'bank-v2',
    meta: { requiresAuth: true, permission: 'view-bank-profiles' },
    component: () => import('./views/Index.vue')
  },
  {
    path: '/v2/payment/banks/create',
    name: 'bank-v2-create',
    meta: { requiresAuth: true, permission: 'create-bank-profiles' },
    component: () => import('./views/Create.vue')
  },
  {
    path: '/v2/payment/banks/:id/edit',
    name: 'bank-v2-edit',
    meta: { requiresAuth: true, permission: 'update-bank-profiles' },
    component: () => import('./views/Edit.vue')
  }
]
